export const BOOK_ROUTE = '/book/butler-manners-and-culture';
export const SITE_ORIGIN = 'https://butlerbell.jp';
export const BOOK_IMAGE = '/images/book/gakken-butler-manners-cover.jpg';

export const profileBookSchema = {
  '@context': 'https://schema.org', '@type': 'Book',
  '@id': `${SITE_ORIGIN}${BOOK_ROUTE}#book`,
  name: '執事のマナーと教養図鑑', url: `${SITE_ORIGIN}${BOOK_ROUTE}`,
  editor: { '@id': `${SITE_ORIGIN}/#person` },
  publisher: { '@type': 'Organization', name: 'Gakken' },
  datePublished: '2026-09-17', isbn: '9784058027608',
};

export function bookSchema(route: string) {
  const isEnglish = route.startsWith('/en/');
  return {
    ...profileBookSchema,
    '@id': `${SITE_ORIGIN}${route}#book`,
    name: isEnglish ? "執事のマナーと教養図鑑 (A British Butler's Guide to Manners and Culture)" : profileBookSchema.name,
    alternateName: ['英国紳士の美しい暮らしかた 50 Topics', "A British Butler's Guide to Manners and Culture"],
    url: `${SITE_ORIGIN}${route}`, image: `${SITE_ORIGIN}${BOOK_IMAGE}`,
    inLanguage: 'ja', numberOfPages: 144,
    editor: [
      { '@type': 'Person', '@id': `${SITE_ORIGIN}/#person`, name: isEnglish ? 'Butler Bell' : '執事ベル',
        alternateName: isEnglish ? ['執事ベル', 'Butler Bell'] : ['執事ベル', '全日本執事協会 執事ベル'], url: `${SITE_ORIGIN}/`,
        affiliation: { '@id': 'https://butler-association.jp/#organization' } },
      { '@type': 'Organization', '@id': 'https://butler-association.jp/#organization',
        name: '一般社団法人 全日本執事協会', url: 'https://butler-association.jp/' },
    ],
    contributor: { '@type': 'Organization', name: '執事喫茶Swallowtail' },
    illustrator: [{ '@type': 'Person', name: 'ツツイモモエ' }, { '@type': 'Person', name: 'ｏｍｉｓｏ' }],
    offers: { '@type': 'Offer', price: '1870', priceCurrency: 'JPY',
      seller: { '@type': 'Organization', name: 'Amazon.co.jp' } },
  };
}
